<template>
    <div class="fixed z:$(comment-modal-zindex) top:122 {top:84}@<lg left:50% translateX(-50%) opacity:0 pointer-events:none ~opacity|ease|300ms {opacity:1;pointer-events:all}.show" :class="{ show: isOpen }" v-if="content">
        <div class="alert white-space:nowrap p:24|32! r:12! f:18! flex ai:center" :class="alertClass()" role="alert" v-html="content"></div>
    </div>
</template>

<script setup>
    const isOpen = ref(false);
    const content = ref("");
    const alertType = ref("success");

    const alertClass = () => {
        return [`alert-${alertType.value}`];
    };

    const open = () => isOpen.value = true;
    const close = () => isOpen.value = false;

    let handler;

    const clearHandler = () => {
        if (handler) {
            clearTimeout(handler);
        }
        handler = null;
    };

    const show = (type, message, duration) => {
        clearHandler();
        duration = duration || 1500;
        handler = setTimeout(close, duration);

        content.value = message;
        alertType.value = type || "success";
        open();
    };

    const hide = () => {
        clearHandler();
        close();
    };

    const error = (message, duration = 5000) => {
        show("danger", `<i class="fa-solid fa-xmark inline-flex! w:20 h:20 ai:center jc:center color:white bg:#FF6D60 round f:12 mr:12"></i> ${message}`, duration);
    };

    const success = (message, duration = 3000) => {
        show("success", `<i class="fa-solid fa-check inline-flex! w:20 h:20 ai:center jc:center color:white bg:#29B799 round f:12 mr:12"></i> ${message}`, duration);
    };

    defineExpose({ error, hide, show, success });

    const props = defineProps({
        global: { default: false, type: Boolean }
    });

    if (props.global) {
        const global = useGlobal();

        watch(() => global.message, () => {
            if (global.message) {
                if (global.message.error) {
                    error(global.message.error);
                } else {
                    success(global.message);
                }

                global.message = null;
            }
        });
    }
</script>
